import React, { Component } from 'react';
import {
    Alert, Button, Spinner, Table,
} from 'react-bootstrap';
import { connect } from 'react-redux';
import { formatDate } from '../../Utils/formatDate';
import { AuthAPI } from '../../API';
import { PageStatus } from 'enums';
import { Show } from 'Layout';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Form } from "./MyReferralsForm";
import CardHeader from "../Card/CardHeader";
import GridContainer from "../Grid/GridContainer";
import Card from "../Card/Card";
import { withTranslation } from 'react-i18next';
import { PORTAL_CODE } from '../../config/portalBranding';

// Japan portal drops the Phone Number column from the referrals listing
// (mobile is not collected on the JP referral flow). Other portals keep it.
const IS_JAPAN_PORTAL = PORTAL_CODE === 'JP';

const MODAL_TYPES = {
    NONE: 'NONE',
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    DETAILS: 'DETAILS',
    QUESTION: 'QUESTION'
};

const REFERRALS_PAGE_SIZE = 50;

class MyReferrals extends Component<any, any> {
    constructor(props) {
        super(props);
        this.state = {
            referrals: [],
            status: PageStatus.None,
            error: null,
            showRequestWarning: false,
            currentPage: 1,
            hasMore: false,
        };
    }

    componentDidMount() {
        if (this.props.userId) {
            this.fetch(1);
        }
    }

    fetch = (page: number) => {
        Promise.resolve()
            .then(() => this.setState({ status: PageStatus.Loading }))
            .then(() => AuthAPI.referralsListByUserId(REFERRALS_PAGE_SIZE, this.props.userId, page))
            .then((surveyData: any) => {
                const data = Array.isArray(surveyData) ? surveyData : [];
                this.setState({
                    referrals: data,
                    status: PageStatus.Loaded,
                    currentPage: page,
                    hasMore: data.length === REFERRALS_PAGE_SIZE,
                });
            })
            .catch((err) => {
                this.setState({ error: err.message, status: PageStatus.Error });
            });
    };

    render() {
        const lang = this.props.language ?? 'en';
        const { t } = this.props;
        return (
            <>
                <GridContainer>
                    <Card>
                        <CardHeader color="primary">
                            <div className="d-flex align-items-center justify-content-between">
                                <h4 className="text-white cardTitle">{t('referrals.referrals')}</h4>
                                <div>
                                    <Button
                                        onClick={() => {
                                            return this.setState({
                                                formType: MODAL_TYPES.CREATE,
                                            });
                                        }}
                                        variant="primary"
                                        size="sm"
                                        className="mx-1"
                                    >
                                        <FontAwesomeIcon icon={['fas', 'plus']} className="mr-2" />
                                        {t('referrals.referAFriend')}
                                    </Button>
                                </div>
                            </div>
                        </CardHeader>
                    </Card>
                </GridContainer>

                <div className="jumbotron bg-white p-3 border shadow-sm">
                    <Alert variant="danger" show={this.state.status === PageStatus.Error}>
                        {this.state.error}
                    </Alert>
                    <Show when={this.state.status === PageStatus.Loading}>
                        <div className="d-flex justify-content-center w-100 p-5">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    </Show>

                    <Show when={this.state.status === PageStatus.Loaded}>
                        <Show when={!this.state.referrals.length}>
                            <Alert variant="info" show={!this.state.referrals.length}>
                                {t('survey.list.emptyState')}
                            </Alert>
                        </Show>

                        <Show when={this.state.formType === MODAL_TYPES.CREATE}>
                            <Form
                                show={this.state.formType === MODAL_TYPES.CREATE}
                                userId={this.props.userId}
                                onClose={() => this.setState({
                                    formType: MODAL_TYPES.NONE,
                                })}
                                onSubmit={(id) => {
                                    this.fetch(1);
                                    this.setState({
                                        formType: MODAL_TYPES.NONE,
                                    });
                                }}
                                language={lang}
                            />
                        </Show>
                        <Show when={!!this.state.referrals.length}>
                            <Table responsive size="sm" bordered>
                                <thead>
                                    <tr>
                                        <th>{t('common.columnSerialNo')}</th>
                                        <th>{t('common.columnName')}</th>
                                        <th>{t('common.emailLabel')}</th>
                                        {/* Phone Number column hidden for JP — mobile not collected on JP referral flow. */}
                                        {!IS_JAPAN_PORTAL && (
                                            <th>{t('referrals.list.tableColPhoneNumber')}</th>
                                        )}
                                        <th>{t('referrals.list.tableColReferralStatus')}</th>
                                        <th>{t('referrals.list.tableColReferralMethod')}</th>
                                        <th>{t('referrals.list.tableColCreatedAt')}</th>
                                        <th>{t('referrals.list.tableColUpdatedAt')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.referrals.map((referral, index) => (
                                            <tr key={referral.id}>
                                                <td>{(this.state.currentPage - 1) * REFERRALS_PAGE_SIZE + index + 1}</td>
                                                <td>
                                                    <button
                                                        type="button"
                                                        className="text-primary bg-transparent"
                                                        onKeyPress={() => null}
                                                        onClick={() => {
                                                            this.setState({
                                                                formType: MODAL_TYPES.NONE,
                                                                queryId: referral.id,
                                                            });
                                                        }}
                                                    >{referral.name}</button>
                                                </td>
                                                <td>{referral.email}</td>
                                                {!IS_JAPAN_PORTAL && (
                                                    <td>{referral.phoneNumber ? referral.phoneNumber : "-"}</td>
                                                )}
                                                <td>{referral.referralStatus ? t(`referrals.${String(referral.referralStatus).toLowerCase()}`, referral.referralStatus) : referral.referralStatus}</td>
                                                <td>{referral.referralMethod ? t(`referrals.${String(referral.referralMethod).toLowerCase()}`, referral.referralMethod) : referral.referralMethod}</td>
                                                <td>{formatDate(referral.createdAt)}</td>
                                                <td>{formatDate(referral.updatedAt)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-between align-items-center mt-2">
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={this.state.currentPage <= 1}
                                    onClick={() => this.fetch(this.state.currentPage - 1)}
                                >
                                    {t('common.previousButton')}
                                </button>
                                <span>{t('referrals.list.paginationPageLabel', { currentPage: this.state.currentPage })}</span>
                                <button
                                    className="btn btn-sm btn-outline-secondary"
                                    disabled={!this.state.hasMore}
                                    onClick={() => this.fetch(this.state.currentPage + 1)}
                                >
                                    {t('common.nextButton')}
                                </button>
                            </div>
                        </Show>
                    </Show>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        userId: state.adminUser.adminUser.userId,
        role: state.adminUser.adminUser.role,
        phoneNumber: state.adminUser.adminUser.phoneNumber,
        email: state.adminUser.adminUser.email,
        isLoading: state.adminUser.adminUser.loading,
        error: state.adminUser.adminUser.error,
        language: state.adminUser.adminUser.language
    };
};

export default connect(mapStateToProps)(withTranslation()(MyReferrals));
